"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = getConfig;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _canvasIframe = require("tinymce-themes/themes/canvas-iframe");

require("tinymce/plugins/advlist");

require("tinymce/plugins/directionality");

require("tinymce/plugins/lists");

require("tinymce/plugins/noneditable");

require("tinymce/plugins/paste");

require("tinymce/plugins/print");

require("tinymce-plugins/hsformatting");

require("tinymce-plugins/hslink");

require("tinymce-plugins/hsusage");

require("tinymce/plugins/searchreplace");

require("tinymce-plugins/hspatches");

require("tinymce-plugins/hstransformer");

require("tinymce-plugins/hssanitize");

require("tinymce-plugins/hsemoji");

require("tinymce-plugins/hslists");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _FontSettings = require("ContentUtils/constants/FontSettings");

var _staticUrl = require("rich-text-lib/utils/staticUrl");

var _hslink2 = require("tinymce-plugins/constants/hslink");

var _hsSettings = require("tinymce-plugins/constants/hsSettings");

var _plugins = require("tinymce-plugins/constants/plugins");

var _hsformatting2 = require("tinymce-plugins/constants/hsformatting");

var _basic = require("../schemas/basic");

var _Constants = require("../Constants");

var _defaults = require("./defaults");

var _leadFlows = require("../toolbar/lead-flows");

var getPlugins = function getPlugins() {
  return ['directionality', 'lists', 'paste', 'print', 'searchreplace', 'noneditable', 'hspatches', _plugins.HS_FORMATTING, _plugins.HS_LINK, _plugins.HS_USAGE, _plugins.HS_TRANSFORMER, _plugins.HS_SANITIZE, _plugins.HS_EMOJI, _plugins.HS_LISTS];
};

function getConfig() {
  var _LINK_SETTINGS, _HS_FORMATTING, _HS_PLUGINS, _extends2;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var appName = options.appName,
      trackInteraction = options.trackInteraction,
      usageTracker = options.usageTracker,
      minHeight = options.minHeight,
      pickerComponents = options.pickerComponents,
      _options$gates = options.gates,
      gates = _options$gates === void 0 ? [] : _options$gates,
      _options$scopes = options.scopes,
      scopes = _options$scopes === void 0 ? [] : _options$scopes; // Make sure that the base URL used to fetch localizations and plugins
  // that haven't been added to the bundle is correct. While a mutation
  // in a getter is a faux pas, this avoids requiring the app to set
  // the value correctly.

  _tinymce.default.baseURL = (0, _staticUrl.getStaticUrl)('tinymce', '/js/tinymce');
  return (0, _extends3.default)({}, _defaults.settings, (_extends2 = {
    content_css: (0, _staticUrl.getStaticUrl)('tinymce-themes', '/bundles/content-iframe.css'),
    browser_spellcheck: true,
    plugins: getPlugins().join(' '),
    theme: _canvasIframe.CANVAS_IFRAME,
    canvasToolbar: (0, _leadFlows.getCanvasToolbar)(),
    toolbar: [],
    menubar: false,
    // enable uploading of pasted images
    paste_data_images: false,
    // Force wrapping in a <p> so alignment etc functionality works when there's
    // just a single line of text
    forced_root_block: 'p',
    force_p_newlines: false,
    // the skin should be added to the CSS bundle of the app
    skin: false,
    apiClient: _apiClient.default,
    min_height: minHeight || 100,
    valid_elements: _basic.basicSchema,
    // reset extended_valid_elements from settings
    extended_valid_elements: ''
  }, (0, _defineProperty2.default)(_extends2, _hsSettings.HS_INPAGE, false), (0, _defineProperty2.default)(_extends2, _hsSettings.HS_PLUGINS, (_HS_PLUGINS = {
    appName: appName,
    trackInteraction: trackInteraction,
    usageTracker: usageTracker,
    pickerComponents: pickerComponents,
    richTextLibStaticPrefix: (0, _staticUrl.getStaticPrefix)('rich-text-lib')
  }, (0, _defineProperty2.default)(_HS_PLUGINS, _hslink2.LINK_SETTINGS, (_LINK_SETTINGS = {}, (0, _defineProperty2.default)(_LINK_SETTINGS, _hslink2.hslinkConfig.HIDE_TARGET_BLANK_AND_NO_FOLLOW, false), (0, _defineProperty2.default)(_LINK_SETTINGS, _hslink2.hslinkConfig.ALLOW_RELATIVE_LINKS, false), (0, _defineProperty2.default)(_LINK_SETTINGS, _hslink2.hslinkConfig.ALLOW_FILE_DOWNLOAD, false), _LINK_SETTINGS)), (0, _defineProperty2.default)(_HS_PLUGINS, _plugins.HS_FORMATTING, (_HS_FORMATTING = {}, (0, _defineProperty2.default)(_HS_FORMATTING, _hsformatting2.hsformattingConfig.FONT_FORMATS, _Constants.fontFormatList), (0, _defineProperty2.default)(_HS_FORMATTING, _hsformatting2.hsformattingConfig.FONT_SIZE_FORMATS, _FontSettings.FONT_SIZES), (0, _defineProperty2.default)(_HS_FORMATTING, _hsformatting2.hsformattingConfig.LINE_HEIGHTS, _Constants.lineHeightsList), _HS_FORMATTING)), _HS_PLUGINS)), (0, _defineProperty2.default)(_extends2, "gates", gates), (0, _defineProperty2.default)(_extends2, "scopes", scopes), _extends2));
}